import React from 'react';
import { contact } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Hero() {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="hero-gradient"></div>
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            {t(translations.hero.title)}
          </h1>
          <p className="hero-subtitle">
            {t(translations.hero.subtitle)}
          </p>
          <ul className="hero-features">
            {translations.hero.features.map((feature, index) => (
              <li key={index}>{'\u2713'} {t(feature)}</li>
            ))}
          </ul>
          <div className="hero-cta">
            <a href="#about" className="btn btn-primary btn-large">
              {t(translations.hero.learnMore)}
            </a>
            <a href="#products" className="btn btn-secondary btn-large">
              {t(translations.hero.catalog)}
            </a>
          </div>
          <div className="hero-phone-mobile">
            <a href={`tel:${contact.phone}`} className="hero-phone-link">
              <span className="phone-icon">{'\u{1F4DE}'}</span>
              <span>{contact.phone}</span>
            </a>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-badge">
            <div className="badge-content">
              <span className="badge-icon">{'\u{1F3E0}'}</span>
              <span className="badge-title">{t(translations.hero.badgeTitle)}</span>
              <span className="badge-text">{t(translations.hero.badgeText)}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
